import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Shopping({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        fillRule="evenodd"
        d="M11.9999 2C10.159 2 8.66659 3.49238 8.66659 5.33333V6.66667H5.33325C4.99075 6.66667 4.70398 6.9262 4.6699 7.267L3.72993 16.6667H5.06991L5.93658 8H8.66659V10.6667C8.66659 11.0349 8.96506 11.3333 9.33325 11.3333C9.70144 11.3333 9.99992 11.0349 9.99992 10.6667V8H13.9999V10.6667C13.9999 11.0349 14.2984 11.3333 14.6666 11.3333C15.0348 11.3333 15.3333 11.0349 15.3333 10.6667V8H18.0633L18.9299 16.6667H20.2699L19.3299 7.267C19.2959 6.9262 19.0091 6.66667 18.6666 6.66667H15.3333V5.33333C15.3333 3.49238 13.8409 2 11.9999 2ZM13.9999 6.66667V5.33333C13.9999 4.22876 13.1045 3.33333 11.9999 3.33333C10.8953 3.33333 9.99992 4.22876 9.99992 5.33333V6.66667H13.9999Z"
        fill={iconColor}
      />
      <Path
        d="M20.4942 21.114C20.3678 21.2537 20.1883 21.3333 19.9999 21.3333H3.99992C3.81157 21.3333 3.63201 21.2537 3.50562 21.114C3.37923 20.9743 3.31782 20.7878 3.33656 20.6003L3.5966 18H4.93658L4.73658 20H19.2633L19.0633 18H20.4032L20.6633 20.6003C20.682 20.7878 20.6206 20.9743 20.4942 21.114Z"
        fill={iconColor}
      />
    </Svg>
  );
}
